import React, { Component } from 'react';



class Confirmador extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

componentWillMount(){
    document.addEventListener('mousedown',this.handleClick,false);
}

componentWillUnmount(){
    document.removeEventListener('mousedown',this.handleClick,false);
}

handleClick(e){
    if(this.node.contains(e.target)){
        return
    }
    this.props.cerrarModal(0)
}
    

render(){
    const {estado,eliminaSolicitud} = this.props;

    let textoHeader = ""
    let textoBoton1 = ""
    let textoBoton2 = ""
    let textoBoton3 ="Cerrar"
    let accionBoton1 = 3 
    let accionBoton2 = 4
    let clase = "modalConfirmadorSolicitud"

    switch (estado){
        case 2 :{
            textoHeader = "Confirmar o Denegar el Estado Completado"
            textoBoton1 = "Confirmar"
            textoBoton2 = "Denegar"
            accionBoton1 = 3
            accionBoton2 = 4
            break;
        }
        case 3 :{
            textoHeader = "Denegar o Restablecer el Estado Confirmado"
            textoBoton1 = "Denegar"
            textoBoton2 = "Restablecer"
            accionBoton1 = 4
            accionBoton2 = 2
            break;
        }
        case 4 :{
            textoHeader = "Confirmar o Restablecer el Estado Denegado"
            textoBoton1 = "Confirmar"
            textoBoton2 = "Restablecer"
            accionBoton1 = 3
            accionBoton2 = 2
            break;
        }
    }

    if(eliminaSolicitud){
        //SE REUTILIZA EL COMPONENTE PARA EL POP UP DE CONFIRMACION DE ELIMINACIÓN DE SOLICITUD
        textoHeader = "¿Confirma la baja de la Solicitud?"
        textoBoton1 = "Confirmar"
        accionBoton1 = 12
        clase= "modalConfirmadorSolicitud-eliminaSolicitud"
    }

    
    return (
        <div ref={node=>this.node = node} className={clase}>
           <div className="bordeFlechaModalConfirmador"></div>
           <div className="flechaModalConfirmador"></div>
           <div className="rectanguloConfirmador">
                <div className="container-fluid">
                    <div className="col-md-12 headerConfirmador">
                        {textoHeader}
                    </div>
                    <div className="col-md-12 footerConfirmador">
                        <button onClick={()=>{this.props.cambiarEstadoSolicitud(this.props.solicitudId,accionBoton1);this.props.cerrarModal(0)}} style={{marginTop:"17px",marginRight:"12px"}} className="btn btn-primary btn-cta">{textoBoton1}</button>
                        {!eliminaSolicitud && <button onClick={()=>{this.props.cambiarEstadoSolicitud(this.props.solicitudId,accionBoton2);this.props.cerrarModal(0)}} style={{marginTop:"17px",marginRight:"12px"}} className="btn btn-secondary">{textoBoton2}</button>}
                        <button onClick={()=>this.props.cerrarModal(0)} style={{marginTop:"17px"}} className="btn btn-secondary">{textoBoton3}</button>
                    </div>
                </div>
           </div>
        </div>
    );
}

}

export default Confirmador;